import getIn from 'lodash/get';

import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesLyricsState = typeof INITIAL_STATE;

// LYRICS ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_FULL_LYRICS_SUCCESS]: saveLyricData,
});

// CASE FUNCTIONS

function saveLyricData(state: EntitiesLyricsState, action: $TSFixMe): EntitiesLyricsState {
  const pandoraId = getIn(action, 'params.content.trackPandoraId');
  const lyrics = getIn(action, 'response.entities.lyrics', {});
  const lyricData = Object.values(lyrics)[0];

  if (lyricData) {
    return state.mergeDeep({ [pandoraId]: lyricData });
  }
  return state;
}
